import { createContext, useState, useContext } from "react";

const AuthContext = createContext();

// Helper functions for cookies
const setCookie = (name, value, days = 7) => {
  const hostname = window.location.hostname;
  // If local, use localhost. If production, use .smarcu.it to share across subdomains.
  const domain = hostname.includes("localhost")
    ? "localhost"
    : `.${hostname.split(".").slice(-2).join(".")}`;

  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; domain=${domain}; path=/; expires=${expires}; SameSite=Lax`;
};

const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2)
    return decodeURIComponent(parts.pop().split(";").shift());
  return null;
};

const deleteCookie = (name) => {
  const hostname = window.location.hostname;
  const domain = hostname.includes("localhost")
    ? "localhost"
    : `.${hostname.split(".").slice(-2).join(".")}`;
  // Setting expiration date to the past deletes the cookie
  document.cookie = `${name}=; domain=${domain}; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
};

export const AuthProvider = ({ children }) => {
  // Synchronously read from cookies to prevent redirect flashes
  const [user, setUser] = useState(() => {
    const storedUser = getCookie("smarcuit_user");
    return storedUser ? JSON.parse(storedUser) : null;
  });

  const [token, setToken] = useState(() => {
    return getCookie("smarcuit_token") || null;
  });

  const login = (newToken, userData) => {
    setCookie("smarcuit_token", newToken);
    setCookie("smarcuit_user", JSON.stringify(userData));
    setToken(newToken);
    setUser(userData);
  };

  const logout = () => {
    deleteCookie("smarcuit_token");
    deleteCookie("smarcuit_user");
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
